import { NavLink } from "react-router-dom";
import { resolveAssetUrl } from "../baseurl";

export default function CollectionBanner({ content }) {
  const title = content?.shopTitle || "Shop";
  const bannerImage = resolveAssetUrl(
    content?.shopBannerImage
  ) || "";

  return (
    <section className="relative w-full min-h-[414px] mt-24 md:mt-32 flex items-end justify-center bg-black bg-no-repeat bg-contain bg-center" style={{ backgroundImage: `url("${bannerImage}")` }}>
      <div className="absolute inset-0 bg-black/50" />

      <div className="relative flex flex-col items-center px-6 pb-6 text-center">
        <h1 className="text-white font-bold text-[29px] md:text-[34px]">
          {title}
        </h1>

        <div className="flex items-center gap-2 mt-3 text-[17px]">
          <NavLink to="/" className="text-white font-semibold hover:text-teal-400">
            HOME
          </NavLink>
          <span className="text-gray-300">›</span>
          <span className="text-teal-400 font-semibold">{title.toUpperCase()}</span>
        </div>
      </div>
    </section>
  );
}